import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PaymentScenarionFindInterface } from '@zaoblako/shared/modules/task/dtos/payment-scenarion/payment-scenarion-find.dto';
import type { PaymentScenarionPageInterface } from '@zaoblako/shared/modules/task/dtos/payment-scenarion/payment-scenarion-page.dto';
import type { PaymentScenarionQueryInterface } from '@zaoblako/shared/modules/task/dtos/payment-scenarion/payment-scenarion-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentTaskScenarioService extends BaseService {
  protected baseUrl = '/finance/brs/payment-scenarion';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: PaymentScenarionQueryInterface): Observable<PaymentScenarionPageInterface> {
    return this.http.get<PaymentScenarionPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public findWithPagination(queryParams: PaymentScenarionQueryInterface): Observable<PaymentScenarionPageInterface> {
    return this.findPage(queryParams);
  }

  public restoreOne(id: number): Observable<PaymentScenarionFindInterface> {
    return this.http.post<PaymentScenarionFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }
}
